import { render, staticRenderFns } from "./Exception01.vue?vue&type=template&id=ebc81da2&scoped=true&"
import script from "./Exception01.vue?vue&type=script&lang=js&"
export * from "./Exception01.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebc81da2",
  null
  
)

export default component.exports